import React from 'react';
import * as S from './CharacterCounter.styles';
import { ICharacterCounterProps } from './CharacterCounter.model';

const CharacterCounter: React.FC<ICharacterCounterProps> = ({
  currentLength,
  maxLength,
  isError,
}) => {
  return (
    <S.Counter isError={isError || false}>
      {maxLength ? (
        <div>
          {currentLength} / {maxLength}
        </div>
      ) : (
        currentLength
      )}
    </S.Counter>
  );
};

export default CharacterCounter;
